import { chartAyanamshaSettings } from "./customAyanamsha";

export function chartCalculationHeaders(chart: any): Record<string, string> {
  const settings = chartAyanamshaSettings(chart);
  return {
    "x-chart-calculation-version": "1",
    ...(settings ? { "x-chart-ayanamsha": JSON.stringify(settings) } : {}),
  };
}

// Chart-derived calls carry the frozen definition even for unsaved previews.
// Creation calls intentionally omit it: the server reads the signed-in profile.
// Updated clients advertise support before creating a custom chart. Older
// installed builds keep their supported standard calculation modes.
export function isAyanamshaAwareRequest(url: string, apiBase: string): boolean {
  if (
    /^https?:/i.test(url) &&
    !url.startsWith(apiBase.replace(/\/$/, "") + "/")
  )
    return false;
  return /\/(charts|bnn|ashtakavarga|special-ascendants|varshaphal|advanced-tools|advanced-astrology|transits|panchang)(?:\/|$)/.test(
    url.split("?")[0],
  );
}
export function isChartCalculationRequest(
  url: string,
  apiBase: string,
): boolean {
  if (
    /^https?:/i.test(url) &&
    !url.startsWith(apiBase.replace(/\/$/, "") + "/")
  )
    return false;
  const path = url.split("?")[0];
  if (/\/charts\/(calculate|horary|instant-horary)(?:\/|$)/.test(path))
    return false;
  return (
    /\/(charts|bnn|ashtakavarga|special-ascendants|varshaphal|advanced-tools|advanced-astrology)(?:\/|$)/.test(
      path,
    ) || /\/transits\/(double|nadi-nakshatra-scan)(?:\/|$)/.test(path)
  );
}
export function installChartFetch(
  getChart: () => any,
  apiBase: string,
): () => void {
  const original = globalThis.fetch;
  const wrapped: typeof fetch = (input, init) => {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url;
    const snapshot = chartAyanamshaSettings(getChart());
    if (!isAyanamshaAwareRequest(url, apiBase)) return original(input, init);
    const headers = new Headers(
      init?.headers ||
        (typeof Request !== "undefined" && input instanceof Request
          ? input.headers
          : undefined),
    );
    headers.set("x-chart-calculation-version", "1");
    if (
      snapshot &&
      isChartCalculationRequest(url, apiBase) &&
      !headers.has("x-chart-ayanamsha")
    )
      headers.set("x-chart-ayanamsha", JSON.stringify(snapshot));
    return original(input, { ...init, headers });
  };
  globalThis.fetch = wrapped;
  return () => {
    if (globalThis.fetch === wrapped) globalThis.fetch = original;
  };
}
